import type { ReactNode } from "react"
import { createElement } from "react"
import NestedLinkAtm from "@onestore/hel/dist/components/atoms/NestedLinkAtm"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { Components } from "react-markdown"

export const mainSearchPromoText: Components = {
  ...getBaseMarkdownOverrides({
    typography: "xsmall1",
    boldTypography: "xsmall3",
  }),
  a: (({ href, children }: { href?: string; children: ReactNode }) =>
    createElement(NestedLinkAtm, {
      href,
      openInNewTab: true,
      title: href ?? "",
      children,
    })) as Components["a"],
} as Components
